import { Platform } from 'react-native';

export const getOSType = () => {
  const os = Platform.OS;

  if (os === 'ios') {
    return 'iOS';
  }

  if (os === 'android') {
    return 'Android';
  }

  if (os === 'web') {
    return 'Web';
  }

  return 'Unknown';
};
